export default __webpack_public_path__ + "static/media/mixedgases-temp.b7da4aa3.jpg";